// src/Dashboard/admin/layout/Sidebar.jsx
export default function Sidebar({
  logoSrc,
  sidebarExpanded,
  activeSection,
  setActiveSection,
  navItems = [],
}) {
  return (
    <aside
      className={`hidden md:flex flex-col bg-white dark:bg-slate-900 shadow-xl border-r border-slate-200 dark:border-slate-800 transition-all duration-300 ${
        sidebarExpanded ? "w-64" : "w-20"
      }`}
    >
      <div className="flex items-center gap-3 px-4 py-4 border-b border-slate-100 dark:border-slate-800">
        <img
          src={logoSrc}
          alt="VOP Logo"
          className="w-9 h-9 rounded-full object-contain"
        />
        {sidebarExpanded && (
          <div className="min-w-0">
            <div className="text-sm font-semibold truncate">VOP Virtual School</div>
            <div className="text-xs text-slate-500 truncate">Admin Portal</div>
          </div>
        )}
      </div>

      <nav className="flex-1 py-3 space-y-1 overflow-y-auto overflow-x-hidden">
        {navItems.map((item) => {
          if (item.type === "section") {
            return (
              <div
                key={`sec-${item.label}`}
                className={`px-4 pt-3 pb-1 text-[11px] tracking-wide uppercase text-slate-400 dark:text-slate-500 ${
                  sidebarExpanded ? "block" : "hidden"
                }`}
              >
                {item.label}
              </div>
            );
          }

          const Icon = item.icon;
          const isActive = activeSection === item.id;

          return (
            <button
              key={item.id}
              onClick={() => setActiveSection(item.id)}
              className={`group flex items-center gap-3 w-full min-w-0 px-4 py-2.5 text-sm font-medium transition-colors ${
                isActive
                  ? "bg-orange-100/80 text-orange-700 dark:bg-orange-500/20 dark:text-orange-200"
                  : "text-slate-600 dark:text-slate-300 hover:bg-slate-100/80 dark:hover:bg-slate-800/70"
              }`}
            >
              <span className="flex items-center justify-center w-8 shrink-0">
                <Icon
                  size={20}
                  className={
                    isActive
                      ? "text-orange-600 dark:text-orange-200"
                      : "text-slate-400 group-hover:text-slate-600 dark:text-slate-500"
                  }
                />
              </span>
              {sidebarExpanded && <span className="truncate">{item.label}</span>}
            </button>
          );
        })}
      </nav>

      <div className="px-4 py-4 border-t border-slate-100 dark:border-slate-800 text-xs text-slate-500">
        © {new Date().getFullYear()} Voice Of Prophecy
      </div>
    </aside>
  );
}
